import { Directive, HostListener } from '@angular/core';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { assert } from 'ts-essentials';

@Directive({
  selector: 'img',
})
export class ImgLoadDirective {
  constructor(private processEventService: ProcessEventService) {}

  @HostListener('load') onLoad() {
    this.onDomChange();
  }

  private onDomChange(): void {
    const html = document.getElementsByTagName('html')[0];
    assert(html != null);
    const w = html.offsetWidth;
    const h = html.offsetHeight;
    this.processEventService.push(ProcessEventFactory.SpawnWindowResizeEvent(w + '|' + h));
  }
}
